export const MaterialUsageRow = {
  flow: 'x',
  gap: 'Z',
  align: 'center flex-start',
  padding: 'Z B',
  round: 'Z',
  background: 'inkMid',
  border: '1px solid inkBorder',

  MaterialField: {
    flex: '2',
    flow: 'y',
    gap: 'X',
    Label: { text: '{{ material | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
    Value: { text: (el, s) => s.materialName || '', fontSize: 'Z', fontWeight: '600', color: 'inkText' }
  },

  QtyField: {
    flex: '1',
    flow: 'y',
    gap: 'X',
    Label: { text: '{{ qtyUsed | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
    Value: { text: (el, s) => s.quantityUsed != null ? String(s.quantityUsed) : '', fontSize: 'Z', fontWeight: '600', color: 'inkText' }
  },

  UnitField: {
    flex: '1',
    flow: 'y',
    gap: 'X',
    Label: { text: '{{ unit | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
    Value: { text: (el, s) => s.unit || '', fontSize: 'Z', color: 'inkMuted' }
  },

  RemoveBtn: {
    tag: 'button',
    text: '\u2715',
    fontSize: 'Z',
    color: 'red',
    background: 'red.15',
    border: 'none',
    round: 'Y',
    width: 'B',
    height: 'B',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center'
  }
}
